import { api } from './api'

// Serialize list options into the /global-search-chats query string. A chat has
// no item scope, so there are no facets - only free-text `q`, `sort`, and keyset
// pagination.
function buildQuery({ q, cursor, limit, sort, topics, nested } = {}) {
  const params = new URLSearchParams()
  if (q) params.set('q', q)
  if (cursor) params.set('cursor', cursor)
  if (limit) params.set('limit', String(limit))
  if (sort) params.set('sort', sort)
  if (topics?.length) params.set('topics', topics.join(','))
  if (nested) params.set('nested', '1')
  const query = params.toString()
  return query ? `?${query}` : ''
}

// The current user's chats. Resolves to the chats array (first/keyset page).
export function listGlobalChats(options = {}) {
  return api.get(`/global-search-chats${buildQuery(options)}`).then((data) => data.chats)
}

// A single chat by id. Used to rehydrate grid windows on reload where only the
// id was persisted. Resolves to the chat (or null-ish on 404 handling upstream).
export function getGlobalChat(id) {
  return api.get(`/global-search-chats/${id}`).then((data) => data.chat)
}

// Create a chat. Expects { label?, topics? }. Resolves to the new chat.
export function createGlobalChat(payload) {
  return api.post('/global-search-chats', payload).then((data) => data.chat)
}

// Update a chat. Accepts a partial { label?, topics? }. Resolves to the updated chat.
export function updateGlobalChat(id, payload) {
  return api.patch(`/global-search-chats/${id}`, payload).then((data) => data.chat)
}

// Delete a chat. Resolves to the deleted chat.
export function deleteGlobalChat(id) {
  return api.del(`/global-search-chats/${id}`).then((data) => data.chat)
}
